/*
 * The intake form's look, shared with an intake record's drawer
 * (IntakeRecordDrawer.js), which uses the same plate and slant fields. Theme tokens only
 * (src/theme), so the dark and botanical themes follow.
 */

export const formStyle = {
  background: 'var(--c-bg-subtle)',
  border: '1px solid var(--c-border)',
  borderRadius: 8,
  padding: 20,
  marginBottom: 24,
};

export const gridStyle = {
  display: 'grid',
  gridTemplateColumns: 'repeat(auto-fill, minmax(min(220px, 100%), 1fr))',
  gap: 14,
  marginBottom: 16,
};

/* A cell that takes the whole row. `1 / -1` rather than `span 2`: on a phone
 * the grid has one column, and spanning two would add a second one beside
 * the screen. */
export const fullRow = { gridColumn: '1 / -1' };

export const labelStyle = {
  display: 'flex',
  flexDirection: 'column',
  gap: 4,
  fontSize: 14,
  fontWeight: 500,
  minWidth: 0,
};

export const inputStyle = {
  padding: '6px 10px',
  border: '1px solid var(--c-border-strong)',
  borderRadius: 6,
  fontSize: 14,
  fontWeight: 400,
  minWidth: 0,
};

export const btnStyle = (bg) => ({
  background: bg,
  color: 'var(--c-on-accent)',
  border: 'none',
  borderRadius: 6,
  padding: '8px 16px',
  cursor: 'pointer',
  fontSize: 14,
});

export const smallBtn = (bg) => ({
  background: bg,
  color: 'var(--c-on-accent)',
  border: 'none',
  borderRadius: 4,
  padding: '4px 10px',
  cursor: 'pointer',
  fontSize: 12,
});

export const subFormStyle = {
  background: 'var(--c-bg-subtle)', border: '1px solid var(--c-border)', borderRadius: 8, padding: 14,
  marginTop: 12, marginBottom: 12,
};

// A refusal said once, in the theme's danger ink, and announced: focus stays
// on the button that was pressed, so nothing else would say it.
export const errStyle = { color: 'var(--c-danger-fg)', fontSize: 13, margin: '0 0 10px' };

export const hintStyle = { fontSize: 12, color: 'var(--c-text-muted-fg)', margin: '2px 0 10px', fontWeight: 400 };

export const sectionHeading = { fontSize: 14, fontWeight: 700, margin: '0 0 8px' };
